var path = '/HistoricFeatureAssemblage/'

function get (http, id) {
    return http.get(path + `Get?id=${id}&getComponents=true`)
}
function put (http, assemblageDto) {
    return http.put(path + '?saveComponents=true', assemblageDto)
}
function search (http, searchDto) {
    return http.post(path + 'Search?getComponents=true', searchDto)
}

export default {
    get: get,
    put: put,
    search: search
}



// WEBPACK FOOTER //
// ./src/services/siteForm/historicFeatureService.js